import createSagaMiddleware from 'redux-saga';
import {createStore, applyMiddleware, compose} from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { createLogger } from 'redux-logger';

import createRootReducer from './reducer';
import saga from './saga';

export const history = createBrowserHistory()

export default function configureStore(preloadedState) {
    const sagaMiddleware = createSagaMiddleware()
    const loggerMiddleware = createLogger({
        predicate: () => process.env.NODE_ENV === 'development',
    })

    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    //Init middlewares
    const middlewares = [routerMiddleware(history), loggerMiddleware, sagaMiddleware];

    const store = createStore(
        createRootReducer(history), // root reducer with router state
        composeEnhancers(applyMiddleware(...middlewares)));

    sagaMiddleware.run(saga);

    return store;
}
